import * as Types from '../../../../_types/serverTypes';

import { useMutation, UseMutationOptions } from 'react-query';
import { fetcher } from 'src/clients/graphql/idr';
export type SendChangePhoneNumberVerificationCodeMutationVariables = Types.Exact<{
  data: Types.InputMutationData_VerificationCodeReqDto;
}>;


export type SendChangePhoneNumberVerificationCodeMutation = { __typename?: 'Mutations', userMutations?: { __typename?: 'UserMutations', sendChangePhoneNumberVerificationCode?: { __typename?: 'Response_VerificationCodeResDto', isSuccess?: boolean | null | undefined, listDto?: { __typename?: 'List_VerificationCodeResDto', items?: Array<{ __typename?: 'Output_VerificationCodeResDto', verificationCode?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined } | null | undefined } | null | undefined };


export const SendChangePhoneNumberVerificationCodeDocument = `
    mutation sendChangePhoneNumberVerificationCode($data: InputMutationData_VerificationCodeReqDto!) {
  userMutations {
    sendChangePhoneNumberVerificationCode(request: $data) {
      isSuccess
      listDto {
        items {
          verificationCode
        }
      }
    }
  }
}
    `;
export const useSendChangePhoneNumberVerificationCodeMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SendChangePhoneNumberVerificationCodeMutation, TError, SendChangePhoneNumberVerificationCodeMutationVariables, TContext>) =>
    useMutation<SendChangePhoneNumberVerificationCodeMutation, TError, SendChangePhoneNumberVerificationCodeMutationVariables, TContext>(
      'sendChangePhoneNumberVerificationCode',
      (variables?: SendChangePhoneNumberVerificationCodeMutationVariables) => fetcher<SendChangePhoneNumberVerificationCodeMutation, SendChangePhoneNumberVerificationCodeMutationVariables>(SendChangePhoneNumberVerificationCodeDocument, variables)(),
      options
    );